import script from "./HomeFaq.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeFaq.vue?vue&type=script&setup=true&lang=js"

import "./HomeFaq.vue?vue&type=style&index=0&id=5e2fc540&lang=scss"

const __exports__ = script;

export default __exports__